/**
 * Purple theme (admin-only, Oct 2026)
 * The Money Club look across the whole app: a pastel pink-to-purple gradient
 * header on every page with a white page underneath. It sits on top of Pink:
 * the DEVELOPER switch in Settings stores the flag on this phone, and App.js
 * puts data-purple="1" on <html> while the flag is on AND the theme is Pink.
 * Anything Purple doesn't restyle yet stays Pink.
 */
import { useEffect, useState } from 'react';

export const PURPLE_KEY = 'worthly_purple';
export const PURPLE_TOGGLE_EVENT = 'worthly:purple-toggle';
export const PURPLE_APPLIED_EVENT = 'worthly:purple-applied';

export const isPurpleFlagSet = () => {
  try { return window.localStorage.getItem(PURPLE_KEY) === '1'; } catch (e) { return false; }
};

export const setPurpleFlag = (on) => {
  try { window.localStorage.setItem(PURPLE_KEY, on ? '1' : '0'); } catch (e) { /* private mode */ }
  window.dispatchEvent(new Event(PURPLE_TOGGLE_EVENT));
};

export const isPurpleOn = () =>
  typeof document !== 'undefined' && document.documentElement.getAttribute('data-purple') === '1';

// nav: also use the diary-style tab bar (data-purple-nav). Only the
// DEVELOPER switch turns that on. If Purple later becomes a normal theme
// under Themes, call applyPurple(true, false) so everyone else keeps the
// usual tab bar.
export const applyPurple = (on, nav = false) => {
  const el = document.documentElement;
  const was = el.getAttribute('data-purple') === '1';
  if (on) el.setAttribute('data-purple', '1');
  else el.removeAttribute('data-purple');
  if (on && nav) el.setAttribute('data-purple-nav', '1');
  else el.removeAttribute('data-purple-nav');
  if (was !== !!on) window.dispatchEvent(new Event(PURPLE_APPLIED_EVENT));
};

// True while Purple is showing. Re-renders when it's switched on or off.
export const usePurple = () => {
  const [on, setOn] = useState(isPurpleOn);
  useEffect(() => {
    const sync = () => setOn(isPurpleOn());
    sync();
    window.addEventListener(PURPLE_APPLIED_EVENT, sync);
    return () => window.removeEventListener(PURPLE_APPLIED_EVENT, sync);
  }, []);
  return on;
};

// The Money Club gradient and the colours that go with it.
export const PURPLE = {
  headerBg: 'linear-gradient(135deg, #F8D9EC 0%, #EBD5F6 50%, #D9DAF8 100%)',
  title: 'linear-gradient(90deg, #D6388A 0%, #8B2BE2 100%)',
  pink: '#D6388A',
  purple: '#8B2BE2',
  eyebrow: '#7B5AA6',
  ink: '#1E1630',
  muted: '#7D7590',
  page: '#FFFFFF',
  glass: 'rgba(255,255,255,0.55)',
  glassLine: 'rgba(255,255,255,0.85)',
  shadow: '0 6px 22px rgba(120,60,150,0.09)',
};
